import { Component, effect, inject, input, signal } from '@angular/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { forkJoin, of } from 'rxjs';

import { LocationService } from '../../services';

interface Config {
  floorId?: string;
  locationId: string;
  roomId?: string;
}

@Component({
  imports: [
    NgxSkeletonLoaderModule,
  ],
  selector: 'avs-li-space-location',
  templateUrl: './space-location.component.html',
})
export class SpaceLocationComponent {
  config = input.required<Config>();

  protected isLoading = signal<boolean>(false);
  protected locationService = inject(LocationService);
  protected title = signal<string>('');

  constructor() {
    effect(() => {
      this.fetchTitleInfo(this.config());
    });
  }

  private fetchTitleInfo(config: Config) {
    this.isLoading.set(true);

    const location$ = this.locationService.getLocationInfoById(config.locationId);
    const floor$ = config.floorId
      ? this.locationService.getSpaceInfoById(config.locationId, config.floorId)
      : of(null);
    const room$ = config.roomId
      ? this.locationService.getSpaceInfoById(config.locationId, config.roomId)
      : of(null);

    forkJoin({ floor: floor$, location: location$, room: room$ }).subscribe(({ location, floor, room }) => {
      const title = [location?.friendlyName, floor?.friendlyName, room?.friendlyName]
        .filter(name => !!name)
        .join(', ');

      this.isLoading.set(false);
      this.title.set(title);
    });
  }
}
